module.exports = __webpack_public_path__ + "static/img/logo8.5a324cad.png";